import { Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { type InsurerIntegrationProvider } from '../../../../api/types';
import CollapsibleWrapper, { Panel } from '../../../../components/wrappers/CollapsibleWrapper';
import InsurerIntegrationFields from './InsurerIntegrationFields';

export type InsurerIntegrationProps = {
    provider: InsurerIntegrationProvider;
    isUpdate?: boolean;
    disabled?: boolean;
};

const InsurerIntegration = ({ isUpdate = false, provider, disabled = false }: InsurerIntegrationProps) => {
    const { t } = useTranslation(['insurerDetails']);

    return (
        <CollapsibleWrapper defaultActiveKey={t('insurerDetails:cardTitles.insurerIntegration')}>
            <Panel
                key={t('insurerDetails:cardTitles.insurerIntegration')}
                header={t('insurerDetails:cardTitles.insurerIntegration')}
            >
                <Row gutter={14}>
                    <InsurerIntegrationFields
                        disabled={disabled}
                        isUpdate={isUpdate}
                        nested={!isUpdate}
                        provider={provider}
                    />
                </Row>
            </Panel>
        </CollapsibleWrapper>
    );
};

export default InsurerIntegration;
